export default __webpack_public_path__ + "static/media/TFlogo.1869926a.png";